import { render, staticRenderFns } from "./Tab1WeekCurrent.vue?vue&type=template&id=4ee3671a&scoped=true"
import script from "./Tab1WeekCurrent.vue?vue&type=script&lang=js"
export * from "./Tab1WeekCurrent.vue?vue&type=script&lang=js"
import style0 from "./Tab1WeekCurrent.vue?vue&type=style&index=0&id=4ee3671a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee3671a",
  null
  
)

export default component.exports